<style lang="scss">
@import './table-move.scss';
</style>
<template>
  <div class="table-move">
    <slot name="tableMoveSlot"></slot>
    <div class="table-move-scroll">
      <div class="table-move-query">
        <Table
          :columns="tableColumns"
          :data="tableData"
          :no-data-text="tableNoData"
          ref='table'
          highlight-row
          @on-selection-change="onChangeSelect"
          @on-sort-change="onSortChange"></Table>
      </div>
    </div>
    <Row class="table-move-page">
      <i-col span="4" class="l" v-if="paddingBottom === 140">
        <i-select
          v-model="pageSize"
          style="width:80px;"
          @on-change="changePage(1)"
          placement="bottom">
          <Option v-for="item in pageSizeOpts" :value="item" :key="item">{{item}}{{ $t('version.pagesize') }}</Option>
        </i-select>
      </i-col>
      <i-col span="20" class="table-move-page-box">
        <Page
          :total="filterData.length"
          :current="cur"
          :page-size="pageSize"
          :page-size-opts="pageSizeOpts"
          @on-change="changePage"></Page>
      </i-col>
    </Row>
  </div>
</template>
<script>
import bus from '../../libs/bus';

export default {
  name: 'tableMove',
  props: {
    tableName: String, // 引用此组件的ref
    changeData: Array, // 表格要展示的全量数据
    filterKey: Array, // 搜索框按哪些key筛选
    filterValue: String, // 搜索框输入的值
    tableColumns: Array,
    noData: String,
    paddingBottom: {
      type: Number,
      default: 140,
    },
  },
  data() {
    return {
      cur: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      // tableNoData: this.noData,
      // 平台
      platform: {
        1: {
          value: 1,
          name: 'android',
          icon: 'icon-android-r',
        },
        2: {
          value: 2,
          name: 'ios',
          icon: 'icon-iOS-r',
        },
        4: {
          value: 4,
          name: 'windows',
          icon: 'icon-windows-r',
        },
        16: {
          value: 16,
          name: 'html5',
          icon: 'icon-html-r',
        },
        32: {
          value: 32,
          name: 'weichat',
          icon: 'icon-miniprogram-r',
        },
        64: {
          value: 64,
          name: 'quickapp',
          icon: 'icon-kuaiyingyongSDK',
        },
      },
    };
  },
  computed: {
    // 表格提示：加载中 or 未查询到数据
    tableNoData() {
      if (this.filterValue && this.filterData.length === 0) {
        return this.$t('common.nodata');
      }
      return this.noData;
    },
    saveTableData() {
      return JSON.stringify(this.changeData);
    },
    // 搜索后的全量数据
    filterData() {
      const keyArr = this.filterKey;
      let data = [];
      if (!keyArr) {
        data = this.changeData;
      } else {
        // eslint-disable-next-line
        data = this.changeData.filter((item) => {
        // eslint-disable-next-line
          return keyArr.filter((v) => {
            return `${item[v]}`.toLowerCase().indexOf(this.filterValue.toLowerCase()) > -1;
          }).length;
        });
      }
      return data;
    },
    // 表格绑定的数据
    tableData() {
      const ind = this.cur;
      const data = this.filterData;
      let i = ind ? this.pageSize * (ind - 1) : 0;
      const l = i + this.pageSize;
      const show = [];
      const len = l < data.length ? l : data.length;

      for (i; i < len; i += 1) {
        show.push(data[i]);
      }
      return show;
    },
  },
  methods: {
    // 切换页操作
    changePage(num) {
      this.cur = num;
    },
    // 多选框选择事件
    onChangeSelect(select) {
      this.$emit('on-change-select', select);
    },
    /**
     * 下载表格数据
     * @param [String] name {表格对应名称}
     */
    exportTable(name) {
      if (this.$refs.table) {
        const data = JSON.parse(this.saveTableData);
        const returnData = data.map((val) => {
          const a = {};
          Object.keys(val).forEach((i) => {
            a[i] = typeof val[i] === 'string' && val[i].indexOf(',') > -1 ?
              val[i].split(',').join('') : val[i];
          });
          return a;
        });
        const filename = bus.getDownloadName(name);
        this.$refs.table.exportCsv({
          filename,
          columns: this.tableColumns,
          data: returnData,
        });
      }
    },
    // 自定义排序
    onSortChange(obj) {
      this.$emit('on-table-move-sort', obj, JSON.parse(this.saveTableData));
    },
  },
};
</script>
